// removed by extract-text-webpack-plugin
module.exports = {"layout":"layout__14f0w","wrapper":"wrapper__15Ucp","footer":"footer__2O_5L","padChildren":"padChildren__1brle","positionFeedback":"positionFeedback__2fVmk"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/home.scss
// module id = 100
// module chunks = 0